import { Store } from 'redux';

import { selectPageModelNetwork } from 'store/pageModel';
import { ErrorTypes, LoadDataReject } from 'types/load-data-reject-reason';
import {
	fetchConfiguratorsRequest,
	selectConfiguratorsNetwork,
} from 'containers/configurators-listing';

export const ConfiguratorsListingPageLoadData = (store: Store) =>
	new Promise<void>((resolve, reject: LoadDataReject) => {
		const pageModelNetwork = selectPageModelNetwork(store.getState());

		if (pageModelNetwork.isFetched && pageModelNetwork.isFailed) {
			return reject({ type: ErrorTypes.PAGE_MODEL, message: 'No page model data' });
		}

		store.dispatch(fetchConfiguratorsRequest());

		const unsub = store.subscribe(() => {
			const configuratorsNetwork = selectConfiguratorsNetwork(store.getState());

			if (configuratorsNetwork.isFetched) {
				unsub();
				if (configuratorsNetwork.isFailed) {
					return reject({
						type: ErrorTypes.DATA,
						message: 'Configurators data was not fetched',
					});
				} else {
					return resolve();
				}
			}
		});
	});
